import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, 
  FaFacebookF, FaInstagram, FaTwitter, FaYoutube, 
  FaChevronRight, FaCompass, FaHeart, FaShieldAlt
} from 'react-icons/fa';
import './Footer.css';
import { Link } from 'react-router-dom'; // Make sure react-router-dom is installed

const Footer = () => {
  return (
    <footer className="chandrama-premium-footer">
      <div className="footer-bg-blur"></div>
      
      <motion.div 
        className="footer-inner"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.8 }}
      >
        <div className="footer-main-row">
          
          <div className="footer-column brand-col">
            <h2 className="f-text-logo">Chandrama <span>Holidays</span></h2>
            <p className="f-mission">
              Since 2012, we’ve been creating well-planned travel experiences backed by transparency, comfort, and dependable service.
            </p>
            <div className="f-socials">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/chandrama_holidays?igsh=OXIxNXhlOHRuajds&utm_source=qr" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </div>

          <div className="footer-column links-col">
            <h4>Explore Packages</h4>
            <ul>
              <li><a href="/holiday#domestic-packages"><FaChevronRight className="li-icon" />Domestic Tours</a></li>
              {/* <li><a href="/holiday#special-packages"><FaChevronRight className="li-icon" />Special Packages</a></li> */}
              <li><a href="/holiday#international-tours"><FaChevronRight className="li-icon" />International Tours</a></li>
              <li><a href="/holiday#customized-tours"><FaChevronRight className="li-icon" />Customized Tours</a></li>
              <li><a href="/holiday#adventure-packages"><FaChevronRight className="li-icon" />Adventure Tours</a></li>
            </ul>
          </div>

          <div className="footer-column contact-col">
            <h4>Contact Details</h4>
            <div className="f-contact-info">
              {/* Google Maps Redirect */}
              <div className="f-info-item">
      <FaMapMarkerAlt className="f-icon-main" />
      <p>Shakti Chambers, Sangamvadi, Pune 411003</p>
    </div>
              <a href="tel:+919923562524" className="f-info-item">
                <FaPhoneAlt className="f-icon-main" />
                <p>+91 9923562524</p> 
              </a>
              
              <a href="tel:+919325779623" className="f-info-item">
                <FaPhoneAlt className="f-icon-main" />
                <p>+91 9325779623</p>
              </a>
              
              <a href="mailto:chandramaholidays12@gmail.com" className="f-info-item">
                <FaEnvelope className="f-icon-main" />
                <p>chandramaholidays12@gmail.com</p>
              </a>
            </div>
          </div>

          <div className="footer-column trust-col">
            <h4>Why Choose Us?</h4>
            <div className="trust-icons">
              <div className="t-box"><FaCompass /> <span>Why Travel With Us?</span></div>
              <div className="t-box"><FaShieldAlt /> <span>14+ Years of Travel Expertise</span></div>
              <div className="t-box"><FaHeart /> <span> Personalized Tour Planning</span></div>
              <div className="t-box"><FaShieldAlt /> <span> Reliable & Transparent Service</span></div>
            </div>
          </div>

        </div>

        <div className="footer-bottom-line">
          <p>© 2026 Chandrama Holidays | Crafted with Love for Travelers</p>
          <div className="f-bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms & Conditions</Link>
          </div>
        </div>
      </motion.div>
    </footer>
  );
};

export default Footer;